import React, { useRef } from 'react';
import api from './setAxios';

const Footer=()=>{
    const emailRef = useRef(null);

    const handleMember = (event) => {
        event.preventDefault();
        const emailValue = emailRef.current.value; 

        try {
            const response = api.post("/Comment/SubmitNewsMember", {
                Email: emailValue
            });
        } catch (error) {
            console.error('Error liking the article:', error.response.data);
        }
    };

    return (
        <>
            <footer className='footer' >
                <div className='footer-body' >
                    <div className='footer-body-nav'>
                          <nav>
                            <ul>
                                <li><a target="_blank" href="https://www.toorangco.com" >فروشگاه تورنگ</a></li>
                                <li><a target="_blank" href="https://www.toorangco.com/home/contactus" >تماس با ما</a></li>
                                <li><a target="_blank" href="https://www.toorangco.com/home/infopages/aboutus" >درباره ما</a></li>
                            </ul>
                          </nav>
                        <form className="news-letter newsletter-form" onSubmit={handleMember}>
                            <label htmlFor="news-letter" className="news-letter-txt">
                                عضویت در خبرنامه
                            </label>
                            <input id="email" ref={emailRef} type="email" name="email" placeholder="آدرس ایمیل خود را وارد کنید" className="news-letter-email" dir="ltr"  />
                            <input name="submit" type="submit" id="submit-comment" className="btn news-letter-btn" value="عضویت" />
                            <div className="newsletter-message"></div>
                        </form>
                    </div>
                    <div className="footer-bottom">
                        <div className="footer-text">
                            <div className="about">
                                <p>شرکت تورنگ دارای بیش از 30 سال سابقه فعالیت در حوزه صنعت چاپ، بسته بندی و تبلیغات است. تولید، طراحی و چاپ انواع پاکت، کاغذ، جعبه و کیسه بسته بندی، نایلون و نایلکس تبلیغاتی، ساک های پارچه ای و... بخشی از خدمات و محصولات تورنگ است.</p>
                            </div>
                            <div className="copy-right">
                               © تمامی حقوق متعلق به فروشگاه تورنگ می‌باشد. هر گونه استفاده از مطالب تورنگ بلاگ بدون کسب مجوز کتبی ممنوع است.

                            </div> 
                        </div>
                    </div>
                    <div className="social-networks">
                        <ul className="social-media-links">
                            <li>
                                <a href="https://www.facebook.com/toorangprint" target="_blank">
                                    <i className="fab fa-facebook-f"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://twitter.com/toorangco" target="_blank">
                                    <i className="fab fa-twitter"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.pinterest.com/toorangco" target="_blank">
                                    <i className="fab fa-pinterest"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/toorang.co" target="_blank">
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/company/toorang" target="_blank">
                                    <i className="fab fa-linkedin"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.youtube.com/channel/UChs0CphTpFe4TlyXDwR-5dQ/featured" target="_blank">
                                    <i className="fab fa-youtube"></i>
                                </a>
                            </li>
                        </ul>

                    </div>  
                </div>
            </footer>
        </>
    )
}
export default Footer;